export interface NumberFormState {
    levelId: number | undefined;
    connectFlowId: number | null | undefined;
    mediaLabel: string | null | undefined;
}
